import { Component, OnInit } from '@angular/core';
import {PortalEvent} from '../../classes/calendar';
import {CalendarService} from '../../services/calendar.service';


@Component({
  selector: 'app-unsubscribed-event-list',
  templateUrl: './unsubscribed-event-list.component.html',
  styleUrls: ['./unsubscribed-event-list.component.css']
})
export class UnsubscribedEventListComponent implements OnInit {


	bLoading = true;
  unsubscribedEvents: PortalEvent[] = [];

	constructor(
	private calendarService: CalendarService,
	) {}

  ngOnInit(): void {

    const unsubscribedEventIds = this.calendarService.getUnsubscribedEventIds();

    this.calendarService.getPortalEvents().subscribe( events => {

		this.bLoading = false;
		this.unsubscribedEvents = events.filter( e => unsubscribedEventIds.includes( e.id ) );

    } );


  }

}
